import { render, staticRenderFns } from "./FormHistoricalFigure.vue?vue&type=template&id=0ae09280&"
import script from "./FormHistoricalFigure.vue?vue&type=script&lang=js&"
export * from "./FormHistoricalFigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ae09280')) {
      api.createRecord('0ae09280', component.options)
    } else {
      api.reload('0ae09280', component.options)
    }
    module.hot.accept("./FormHistoricalFigure.vue?vue&type=template&id=0ae09280&", function () {
      api.rerender('0ae09280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/historicalFigure/form/FormHistoricalFigure.vue"
export default component.exports